import React from 'react';
import {motion} from 'framer-motion';

const CTAButton = ({text = "Get Your Instant Online Quote", className = "", size = "lg", onClick}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Always use your affiliate link for all CTAs
      window.open('https://quote.burbankinsuranceservices.com/GQ7uHU', '_blank');
    }
  };

  const sizeClasses = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base", 
    lg: "px-8 py-4 text-lg",
    xl: "px-10 py-5 text-xl"
  };

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={handleClick}
      className={`
        bg-gradient-to-r from-primary-600 to-primary-700 
        hover:from-primary-700 hover:to-primary-800 
        text-white font-bold rounded-lg shadow-lg hover:shadow-xl 
        transition-all duration-300 transform hover:-translate-y-1
        ${sizeClasses[size]} ${className}
      `}
    >
      {text}
    </motion.button>
  );
};

export default CTAButton;